import { watch, type App as VueApp } from 'vue';
import type { Router } from 'vue-router';

import {
  cookieConsentController,
  CookieConsentDecision,
  isObservabilityEnabled,
  observability,
  ProjectSettings,
  reportWebVitals,
} from '@/shared/lib';

const initObservability = (app: VueApp<Element>, router: Router): void => {
  let isInitialized: boolean = false;

  watch(
    cookieConsentController.decision,
    (decision: CookieConsentDecision | null): void => {
      if (
        decision !== CookieConsentDecision.ACCEPTED ||
        !isObservabilityEnabled() ||
        (import.meta.env.PROD && !ProjectSettings.legal.isProductionReady) ||
        isInitialized
      ) {
        return;
      }

      isInitialized = true;

      observability.init({
        app,
        dsn: import.meta.env.SENTRY_DSN,
        beforeSend(event) {
          event.tags = {
            ...event.tags,
            app: 'chat-web-frontend',
          };
          return event;
        },
      });

      router.onError((error) => {
        observability.captureException(error);
      });

      reportWebVitals();
    },
    { immediate: true },
  );
};

export { initObservability };
